import { render, staticRenderFns } from "./Prism.vue?vue&type=template&id=2c2e9bdc&scoped=true&"
import script from "./Prism.vue?vue&type=script&lang=js&"
export * from "./Prism.vue?vue&type=script&lang=js&"
import style0 from "./Prism.vue?vue&type=style&index=0&id=2c2e9bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e9bdc",
  null
  
)

export default component.exports